module.exports = __webpack_public_path__ + "img/map-pin.1988bf74.svg";